export default __webpack_public_path__ + "static/media/room.6d403bb8.png";